import { useCallback, useEffect, useState } from "react";
import { App } from "antd";
import { fetchStoreData } from "../api";

export default function useStoreData() {
  const { message } = App.useApp();
  const [products, setProducts] = useState([]);
  const [users, setUsers] = useState([]);
  const [points, setPoints] = useState(0);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    const userId = parseInt(localStorage.getItem("user_id") || "0", 10);
    const token = localStorage.getItem("token");

    if (!userId || !token) {
      message.error("Usuario no identificado o sin token");
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const data = await fetchStoreData(userId, token);
      setProducts(data.products);
      setUsers(data.users);
      setPoints(data.points);
    } catch (error) {
      console.error(error);
      message.error("Error al cargar datos");
    } finally {
      setLoading(false);
    }
  }, [message]);

  useEffect(() => {
    reload();
  }, [reload]);

  return { products, setProducts, users, points, setPoints, loading, reload };
}
